/**
 * Utility functions for payroll and PF calculations on the frontend.
 */

export const calculatePFEstimate = (monthlyBasic, pfConfig = {}, lopDays = 0, monthlyDA = 0) => {
    const divisor = 30.45;
    const paidDays = Math.max(0, divisor - Number(lopDays || 0));
    const basicVal = Number(monthlyBasic || 0);
    const daVal = Number(monthlyDA || 0);
    const wageVal = basicVal + daVal;
    const wageForPf = (wageVal / divisor) * paidDays;
    const cfgType = pfConfig?.type || 'percentage';
    const proRateLop = pfConfig?.pro_rate_on_lop !== false;

    const calcSingle = (isEmployer = false) => {
        let slabs = pfConfig?.slabs || [];
        let currentType = cfgType;

        if (isEmployer && pfConfig?.employer_matches_employee === false) {
            if (pfConfig?.employer_slabs && pfConfig.employer_slabs.length > 0) {
                slabs = pfConfig.employer_slabs;
                currentType = 'slabs';
            }
        }

        if (currentType === 'slabs' && slabs.length > 0) {
            let matched = slabs.find((s) => {
                const min = Number(s.min_salary || 0);
                const max = s.max_salary !== null && s.max_salary !== undefined && s.max_salary !== '' ? Number(s.max_salary) : Infinity;
                return wageVal >= min && wageVal <= max;
            });
            if (!matched) {
                matched = wageVal < Number(slabs[0]?.min_salary || 0) ? slabs[0] : slabs[slabs.length - 1];
            }

            const calcType = matched.calc_type || 'percentage';
            const val = Number(matched.value || 0);
            const cap = matched.cap !== null && matched.cap !== undefined && matched.cap !== '' ? Number(matched.cap) : null;

            if (calcType === 'flat') {
                return Math.round((val / divisor) * paidDays * 100) / 100;
            } else {
                let amt = wageForPf * (val / 100);
                if (cap !== null && cap > 0) {
                    const effCap = proRateLop ? (cap / divisor) * paidDays : cap;
                    amt = Math.min(amt, effCap);
                }
                return Math.round(amt * 100) / 100;
            }
        }

        if (currentType === 'flat') {
            const val = Number(pfConfig?.value ?? 3000);
            return Math.round((val / divisor) * paidDays * 100) / 100;
        }

        // Default standard percentage mode (EPFO cap of 3000 on Basic + DA)
        const rate = Number(pfConfig?.value ?? 12) / 100;
        return Math.round(Math.min(wageForPf * rate, 3000) * 100) / 100;
    };

    const employeePF = calcSingle(false);
    const employerPF = pfConfig?.employer_matches_employee === false ? calcSingle(true) : employeePF;

    return { employeePF, employerPF };
};
